import { InjectionToken } from '@angular/core';

/**
 * Backend URLs come only from the runtime file `assets/app-settings.js`, which index.html
 * loads before bootstrap. Each `var` in that file is a window global, so a deployment can
 * change a URL without a rebuild.
 */
function readSetting(name: string): string {
  const value = (window as any)[name];
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`Runtime setting "${name}" is missing. Define it in assets/app-settings.js.`);
  }
  return value;
}

/** AvsecPortal.Api base URL (`baseUrl` in app-settings.js), no trailing slash. */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: () => readSetting('baseUrl').replace(/\/$/, ''),
});

/** CAA backend API base URL (`apiRoot` in app-settings.js), no trailing slash. */
export const BACKEND_API_BASE_URL = new InjectionToken<string>('BACKEND_API_BASE_URL', {
  providedIn: 'root',
  factory: () => readSetting('apiRoot').replace(/\/$/, ''),
});
